import PersonaPage from "./PersonaPage";

const questions = [
  { q: "Wie haben Sie sich kennengelernt?", why: "Der erste Blick, der erste Satz, der erste Sommer — die Rede darf dort beginnen, wo alles begann." },
  { q: "Was war Ihre gemeinsame Art?", why: "Reisen, Stille, Musik, ein Sonntagsritual — das gemeinsam Gewachsene trägt die Rede." },
  { q: "Ein Satz, den er/sie oft sagte.", why: "Ein Kosename, eine Redewendung, ein leises Wort im Abschied. Das wird der Kern." },
  { q: "Ein Moment, an dem Sie ihn/sie am meisten geliebt haben.", why: "Nicht das Große — der stille Augenblick im Alltag. Genau der bleibt." },
  { q: "Was haben Sie gemeinsam getragen?", why: "Krankheit, Erfolge, Kinder, Umzüge — die Landkarte eines gemeinsamen Lebens." },
  { q: "Wie soll die Rede klingen?", why: "Persönlich, würdig, mit einem stillen Lächeln oder in großer Ernsthaftigkeit — Sie geben den Ton." },
  { q: "Was möchten Sie den anderen sagen?", why: "Eine Trauerrede für den Ehepartner spricht auch zu den Kindern, Freunden, Enkeln." },
  { q: "Wie lang darf sie sein?", why: "Kurz, mittel oder ausführlich — eine Liebeserklärung darf jede Länge haben, die sie trägt." },
];

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für den Ehepartner?",
    a: "Beginnen Sie nicht mit dem Tod, sondern mit dem Anfang — dem ersten Blick, dem ersten Sommer. Von dort aus wird die Rede eine leise Liebeserklärung, die alles Nachfolgende trägt. Unser Fragebogen führt Sie in acht Schritten dorthin — behutsam, ohne Sie zu drängen.",
  },
  {
    q: "Ich weiß nicht, ob ich es aushalten werde, die Rede zu halten.",
    a: "Das ist verständlich — und ehrlich. Viele Angehörige lassen die Rede von einer nahestehenden Person vortragen. Wir schreiben den Entwurf so, dass er auch aus einem anderen Mund würdig klingt. Sie entscheiden am Tag selbst.",
  },
  {
    q: "Wie viel darf ich von uns preisgeben?",
    a: "So viel, wie sich für Sie richtig anfühlt. Eine Trauerrede für den Ehepartner darf intim sein — sie muss es nicht. Wir helfen Ihnen, die Grenze zu finden, an der Nähe würdig bleibt.",
  },
  {
    q: "Was, wenn wir schwere Zeiten hatten?",
    a: "Ein langes Leben zu zweit ist selten nur leicht. Die Rede darf das benennen — nicht als Vorwurf, sondern als Beweis, dass Sie geblieben sind. Genau das ist Liebe im Erwachsenenalter.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für einen Mann", to: "/trauerrede-mann" },
  { label: "Trauerrede für eine Frau", to: "/trauerrede-frau" },
];

export default function TrauerredeEhepartner() {
  return (
    <PersonaPage
      slug="trauerrede-ehepartner"
      metaTitle="Trauerrede für den Ehepartner schreiben — die letzte Liebeserklärung | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für den Ehemann oder die Ehefrau. Aus einem gemeinsamen Leben wird ein würdevoller Entwurf — sofort verfügbar. Ab 29 €."
      eyebrow="Trauerrede · Ehemann · Ehefrau · Partner"
      headline={
        <>
          Eine Trauerrede für ihn. Für sie.
          <br />
          <span className="italic text-umber">Die letzte Liebeserklärung.</span>
        </>
      }
      intro="Ein Leben zu zweit lässt sich nicht in wenige Minuten fassen. Aber es lässt sich in wenigen Sätzen so berühren, dass alle im Raum wieder sehen, wer Sie zusammen waren. Ein behutsamer erster Entwurf — aus acht ruhigen Fragen."
      heroImage="https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=1920&q=80"
      heroImageAlt="Zwei Kaffeetassen auf einem alten Holztisch im Morgenlicht — Sinnbild eines gemeinsamen Lebens und einer Trauerrede für den Ehepartner"
      questions={questions}
      exampleQuote={
        <>
          „Wir haben uns kennengelernt, als der Sommer schon fast vorbei war. Er hatte diese Art,
          zwischen zwei Sätzen zu schweigen, und ich wusste nach zwei Wochen, dass ich in diesen
          Pausen mein Leben lang gerne wohnen würde. Neununddreißig Jahre lang habe ich dort
          gewohnt. Und ich weiß heute, an diesem Tag: Es war das richtige Zuhause.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
